import { createMiddleware } from '@shared/redux';
import {
    acceptUpdateUserSettings,
    rejectUpdateUserSettings,
    UPDATE_USER_SETTINGS_SUBMITTED,
} from '@domain/settings/update-settings/update-settings.state';
import { saveNewLoggedUser } from '@domain/logged-user/logged-user.state';
import { saveUserSettings } from '@shared/api/users-settings-api';
import { showErrorToast, showSuccessToast } from '@shared/toasts/toasts.state';
import { TOAST_MESSAGES } from '@domain/settings/update-settings/update-settings-modal/update-settings-modal.constants';

export const updateUserSettingsMiddleware = createMiddleware({
    [UPDATE_USER_SETTINGS_SUBMITTED]: async (state, action) => {
        try {
            const userProfile = action.payload;
            const updatedUserProfile = await saveUserSettings(userProfile);
            updatedUserProfile.company = state.loggedUser.data.company;
            updatedUserProfile.waiting_list = state.loggedUser.data.waiting_list;
            return [
                saveNewLoggedUser(updatedUserProfile),
                acceptUpdateUserSettings(),
                showSuccessToast({
                    message: TOAST_MESSAGES.SUCCESS,
                }),
            ];
        } catch (error) {
            return [
                rejectUpdateUserSettings({ error }),
                showErrorToast({
                    message: TOAST_MESSAGES.ERROR,
                }),
            ];
        }
    },
});
